import { render, staticRenderFns } from "./pipeboundary.vue?vue&type=template&id=755248b6&scoped=true&"
import script from "./pipeboundary.vue?vue&type=script&lang=js&"
export * from "./pipeboundary.vue?vue&type=script&lang=js&"
import style0 from "./pipeboundary.vue?vue&type=style&index=0&id=755248b6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "755248b6",
  null
  
)

export default component.exports